import { Injectable, OnDestroy} from '@angular/core';
import { AjaxService } from '../../services/ajax.service';
import * as $ from 'jquery';
window['$'] = window['jQuery'] = $;
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { EmitterService } from '../../services/emitter.service';

@Injectable({
  providedIn : 'root'
})
export class EnvironmentService implements OnDestroy {
  config: any;
  isProfileCompleted;
  userDetails;
  destroy$: Subject<boolean> = new Subject<boolean>();
  activeLanguages;
  constructor(
    private ajaxService: AjaxService,
    private emitterService:EmitterService  
  ) {
    
  }

  loadActiveLanguagesConfig():Promise<void>{
    return this.ajaxService.getActiveLanguage().pipe(takeUntil(this.destroy$)).toPromise().then(config=>{
      this.config = config
      //emitting data for promotion module
      let activeLanguages = this.config ? Object.keys(this.config.data) : ['en'];
      let mappedLanguages = activeLanguages.map(lang=> lang === 'ei' ? 'in' : lang)
      this.emitterService.broadcastActiveLanguages(mappedLanguages)
    })
    .catch(error=>{
      console.log("Error in loading configuration ", error)
    });
  }

   // Method to get a specific configuration value
   getActiveLanguageConfig(): any {
     let activeLanguages = this.config ? Object.keys(this.config.data) : ['en'];
     let mappedLanguages = activeLanguages.map(lang=> lang === 'ei' ? 'in' : lang)
    return mappedLanguages; 
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
